import styled from '@emotion/styled'
export const StyleButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
export const StyleButton = styled.button`
  border: 0px;
  background: ${(props: any) => props.theme.colors.danger};
  padding: 10px 15px;
  border-radius: 4px;
  outline: none;
  color: ${(props: any) => props.theme.colors.white};
  font-size: 12px;
`

export const StyleCanvasBg = styled.div<any>`
  border: 1px solid
    ${(props: any) =>
      !!props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  border-radius: 8px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: white;
`

export const StyleCanvasWrapper = styled.div<any>`
  width: 350px;
  height: 250px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleSignatureImageWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  width: 100px;
  height: 100px;
`

export const StyleSignatureImage = styled.img<any>`
  width: 100px;
`
